var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGameVolatilityFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 3527.7802 1976.0401",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g937",
    transform: "translate(-352.77,-1128.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    className: "fil0",
    d: "M 2905.87,1500.17 2013.8,2952.85 c -58.31,94.38 -161.35,151.83 -272.29,151.83 -176.77,0 -320.07,-143.29 -320.07,-320.06 0,-88.67 36.79,-173.37 101.59,-233.9 z M 1747.5,2586.05 c 111.14,0 201.23,90.09 201.23,201.23 0,111.14 -90.09,201.23 -201.23,201.23 -111.14,0 -201.23,-90.09 -201.23,-201.23 0,-111.14 90.09,-201.23 201.23,-201.23 z",
    id: "path933"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "m 3880.55,2707.82 c 0,28.3 -0.85,56.59 -2.55,84.86 l -649.75,0.1 c -19.74,-324.3 -150.26,-617.57 -354.15,-845.39 l 307.31,-498.58 c 424.74,288.36 699.14,744.97 699.14,1259.01 z M 2435.1,1615.13 c -193.94,-95.16 -412.56,-148.62 -643.32,-148.62 -761.46,0 -1391.12,581.35 -1436.46,1326.27 -1.7,-28.3 -2.55,-56.63 -2.55,-84.96 0,-872.16 789.72,-1579.18 1763.89,-1579.18 271.59,0 528.82,54.98 758.6,153.16 z",
    id: "path935"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameVolatilityFast);
export default __webpack_public_path__ + "static/media/icon-game-volatility-fast.d7c1fa1d377c1abfd0f3e255b0a1323b.svg";
export { ForwardRef as ReactComponent };